export default __webpack_public_path__ + "static/PM__milk-b4976890a8b504da7121e75ba65f8dc1.png";